import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/nlp/tranform_nlp.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud nlp_advance_solution"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={8} xxl={8} className="offset-xl-4">
            <h2>
              Transform Scattered Data into Insights with{" "}
              <span>Advanced NLP Solutions</span>
            </h2>
            <p>
              Our NLP development services combine artificial intelligence,
              machine learning, and linguistics to deliver powerful text
              processing capabilities. Integrate our NLP solutions into your
              applications and chatbots to simplify complexity and accelerate
              data/document processing. Leverage our expertise to build
              contextually aware digital assistants that enhance communication
              and support better decision-making.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              See How it Works
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
